<template>
  <div class="mb-2 fs-14">
    <v-icon
      :color="iconColor"
      class="mr-1"
      data-unit-test="icon"
    >
      {{ optionIcon }}
    </v-icon>
    {{ fullTitle(title) }}
    <p
      v-if="optionPriceLabel"
      class="ml-8 mb-0"
      :class="selected && 'caption'"
      data-unit-test="priceLabel"
      v-html="optionPriceLabel"
    />
  </div>
</template>

<script>
import {
  OPTIONAL_EXTRAS_STATES_ICONS,
} from '@/constants/common';

export default {
  name: 'results-optional-extra-mobile',
  inject: ['constants'],
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    extra: {
      type: Object,
      required: false,
      default: () => {},
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    iconColor () {
      if (this.selected && this.extra?.included === 'extra') {
        return 'accent';
      }

      return 'primary';
    },
    optionIcon () {
      if (this.selected) {
        return 'mdi-check';
      }

      return OPTIONAL_EXTRAS_STATES_ICONS[this.extra.included];
    },
    optionPrice () {
      const price = this.extra.cost?.value;

      if (price === 0) {
        return 'Check provider';
      }

      return 'Added';
    },
    optionPriceLabel () {
      const extraCost = this.extra?.cost;
      const included = this.extra?.included;

      if (!extraCost || typeof extraCost !== 'object') {
        return null;
      }

      if (this.selected) {
        return this.optionPrice;
      }

      if (included === 'extra' && extraCost.value === 0) {
        return 'Check with provider';
      }

      if (included === 'extra' && extraCost.value > 0) {
        return `Available ${extraCost.text} &pound;${extraCost.value.toFixed(2)}`;
      }

      if (included === 'Y') {
        return extraCost.text;
      }

      return 'Not available';
    },
  },
  methods: {
    fullTitle (extra) {
      const mappedOptions = Object.fromEntries(this.constants.OPTIONAL_EXTRAS_OPTIONS.map(o => [o.value, o.label]));

      return mappedOptions[extra] || extra;
    },
  },
};
</script>
